import http from '@/utils/http'  //引入axios
export  const  getTranscation = data=>http.get('/rvm-center/api/transaction',{params:data}) //查找交易记录
export default{
    getTranscation
}